const sidebarPaths = {
  getDashboardLayout: '/dashboard',
  getProductLayout: '/product',
  getProductEditLayout: (id = ':id') => `/product/${id}`,
  getBundlesLayout: '/bundles',
  getBundleEditLayout: (id = ':id') => `/product/bundles/${id}`,
  getCampaignLayout: '/campaign',
  getCampaignEditLayout: (id = ':id') => `/campaign/${id}`,
  getCampaignPageSettingsLayout: '/campaign',
  getOrderLayout: '/order',
  getPaymentLayout: '/payment',
  getReportLayout: '/reports',
  getAdminLayout: '/admin',
  getAccountLayout: '/account',
};

export default sidebarPaths;
